import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../MainPage.css';

const AboutModal = ({ isOpen, onClose }) => {
    return (
        <AnimatePresence>
            {isOpen && (
                <div className="modal-overlay" onClick={onClose}>
                    <motion.div
                        className="modal-content glass-panel about-modal"
                        onClick={(e) => e.stopPropagation()}
                        initial={{ opacity: 0, scale: 0.9, y: 20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.9, y: 20 }}
                        transition={{ type: "spring", damping: 25, stiffness: 300 }}
                    >
                        <button className="modal-close-btn" onClick={onClose}>&times;</button>

                        <div className="about-header">
                            <h2 className="about-title">Hi, Joshua です!</h2>
                            <div className="about-divider"></div>
                        </div>

                        <div className="about-body">
                            <p>
                                I have always been super passionate about computers and programming since a young age. My first experience with a computer was in 2007, when I was only 4. To this day, I still remember visiting the Google Homepage as my first website, searching and browsing through the Internet at that time.
                            </p>
                            <p>
                                Later on, I enrolled in the <strong>Tianjin Vocational Institute</strong> to study computer networking. I have experience in network design and config, Cisco routers and switches, server administration, hosting, and maintenance. After graduation, I enrolled in <strong>St. Clair College</strong>, studying computer programming and am expected to graduate in April 2026.
                            </p>

                            <h3 className="about-subtitle">Interests & Hobbies</h3>
                            <p>
                                I also have many interests! I love anime, games, and visual novels. I'm also super passionate about audio and keyboards. I'm always interested in learning new things, be it watching videos about the latest tech on YouTube, learning about new frameworks, or experimenting on my game consoles. I love new and technological things; I want to know how deep down everything works and how to change and adjust them to better suit my needs.
                            </p>

                            <h3 className="about-subtitle">Languages</h3>
                            <p>
                                I also speak four languages (with two proficient and two still getting there):
                            </p>
                            <ul className="about-list">
                                <li><strong>Chinese</strong>: Native language</li>
                                <li><strong>English</strong>: Learned when I was 14</li>
                                <li><strong>French</strong>: Learning since 2023</li>
                                <li><strong>Japanese</strong>: Learning since 2023</li>
                            </ul>

                            <div className="about-footer">
                                <p>I would love to join the tech industry, it has always been my dream!</p>
                                <p className="thank-you">Thank you for visiting my page.</p>
                            </div>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};

export default AboutModal;
